import { cn } from '@/lib/utils';
import { ActivitySeverity } from '../types';

const SEVERITY_STYLES: Record<ActivitySeverity, { label: string; classes: string }> = {
  [ActivitySeverity.Info]: {
    label: 'Info',
    classes: 'bg-muted text-muted-foreground ring-border',
  },
  [ActivitySeverity.Notable]: {
    label: 'Notable',
    classes: 'bg-warning/10 text-warning ring-warning/30',
  },
  [ActivitySeverity.Critical]: {
    label: 'Critical',
    classes: 'bg-destructive/10 text-destructive ring-destructive/30',
  },
};

interface SeverityBadgeProps {
  severity: ActivitySeverity;
  className?: string;
}

export function SeverityBadge({ severity, className }: SeverityBadgeProps) {
  const config = SEVERITY_STYLES[severity] ?? SEVERITY_STYLES[ActivitySeverity.Info];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        config.classes,
        className
      )}
    >
      {config.label}
    </span>
  );
}
